import React from "react"
import { ArrowLeftRight } from "lucide-react"

const SwapCityButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="bg-white border border-fresh-green rounded-md p-1 transition-all cursor-pointer"
    >
      <ArrowLeftRight strokeWidth={1} className="w-8 h-5" />
    </button>
  )
}

export default SwapCityButton
